import { render, staticRenderFns } from "./il-shop-layered-navigation.vue?vue&type=template&id=c2edf0a8&scoped=true"
import script from "./il-shop-layered-navigation.vue?vue&type=script&lang=ts"
export * from "./il-shop-layered-navigation.vue?vue&type=script&lang=ts"
import style0 from "./il-shop-layered-navigation.vue?vue&type=style&index=0&id=c2edf0a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2edf0a8",
  null
  
)

export default component.exports